import React from 'react';
import i18n from '@i18n';

const SmallLoader = ({ text }: { text?: boolean }) => (
    <div className="SmallLoader">
        <div className="mini-preloader" />
        {text ? <p>{i18n('commons.term.loading')}</p> : null}
    </div>
);

export default SmallLoader;
